exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".WarrantyPayments_message_pdm8 {\n  color: #787878;\n}\n", ""]);

// exports
exports.locals = {
	"message": "WarrantyPayments_message_pdm8"
};